import React from "react";
import { lifecycleSteps } from "../data/services";

/**
 * EKSELENS360 lifecycle visual.
 * Horizontal connected node flow with the purple star linking phases.
 * Distinctive design moment — board-credible, technical, not decorative.
 */
const Lifecycle = () => {
  return (
    <div className="relative" data-testid="ekselens360-lifecycle">
      {/* Desktop: horizontal connected flow */}
      <div className="hidden lg:block">
        <div className="relative">
          {/* Connecting line */}
          <div className="absolute left-0 right-0 top-[34px] h-px bg-zinc-200" />
          <div className="absolute left-0 top-[34px] h-px bg-[#7737F6]" style={{ width: "100%" }} />
          <div className="grid grid-cols-8 gap-0">
            {lifecycleSteps.map((step, idx) => (
              <div key={step.id} className="relative pt-0 pb-4 px-3 group">
                {/* Step number */}
                <div className="text-[11px] font-semibold tracking-[0.2em] text-zinc-500 uppercase mb-2">
                  0{idx + 1}
                </div>
                {/* Node */}
                <div className="relative flex items-center justify-start">
                  <div className="w-4 h-4 bg-white border-2 border-[#7737F6] rounded-full relative z-10 group-hover:bg-[#7737F6] transition-colors" />
                </div>
                {/* Label & note */}
                <div className="mt-4">
                  <div className="ek-heading text-lg text-black">{step.label}</div>
                  <div className="text-[13px] text-zinc-600 font-light leading-relaxed mt-1">
                    {step.note}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Tablet/Mobile: vertical timeline */}
      <ol className="lg:hidden relative space-y-8 pl-8">
        <div className="absolute left-[7px] top-2 bottom-2 w-px bg-[#7737F6]/40" />
        {lifecycleSteps.map((step, idx) => (
          <li key={step.id} className="relative">
            <div className="absolute -left-[33px] top-1 w-4 h-4 rounded-full bg-white border-2 border-[#7737F6]" />
            <div className="text-[11px] font-semibold tracking-[0.2em] text-zinc-500 uppercase mb-1">
              0{idx + 1}
            </div>
            <div className="ek-heading text-xl text-black">{step.label}</div>
            <div className="text-[14px] text-zinc-600 font-light leading-relaxed mt-1">
              {step.note}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default Lifecycle;
